import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
const TYPE = 'molten.mapRenderer.UserPositionModel';
const layerName = 'molten.userPosition';
const {
  t
} = I18N.ns('molten.dataViewers.map.UserPositionModel');
function create() {
  return {
    type: TYPE,
    layerName: 'molten.userPosition',
    visible: true,
    symbolizer: null,
    name: t('name'),
    showAtZoom: 0,
    hideAtZoom: 23,
    scale: {
      normal: 1.0,
      scaleWithZoom: false,
      scaleFromZoom: 5,
      scaleToZoom: 10,
      scaleToFacter: 1,
      scaleFromFactor: 0
    }
  };
}
export default {
  TYPE,
  create,
  layerName,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('symbolizer'),
  ...ModelUtil.createAllValue('showAtZoom'),
  ...ModelUtil.createAllValue('hideAtZoom'),
  ...ModelUtil.createAllValue('fadeZoom'),
  ...ModelUtil.createAllValue('scale/normal', 'Scale'),
  ...ModelUtil.createAllValue('scale/scaleWithZoom', 'ScalesWithZoom'),
  ...ModelUtil.createAllValue('scale/scaleFromZoom', 'ScaleFromZoom'),
  ...ModelUtil.createAllValue('scale/scaleToZoom', 'ScaleToZoom'),
  ...ModelUtil.createAllValue('scale/scaleToFactor', 'ScaleToFactor'),
  ...ModelUtil.createAllValue('scale/scaleFromFactor', 'ScaleFromFactor')
};